'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var blue={1:'#eef7ff',2:'#deedfd',3:'#bddbf4',4:'#84baeb',5:'#3b8fde',6:'#1176d4',7:'#0d66b8',8:'#09549c',9:'#0a4276',10:'#072d52',inflection:6};exports.default=(0,_createColorPalette2.default)(blue,'blue');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vitalsource/vstui/colors/blue.js
// module id = 529
// module chunks = 162